import { Map } from 'immutable';
import { CLOSE_MODAL, OPEN_MODAL, SET_MODAL_MESSAGE } from './constants';

export const initialState = Map({
	modalOpen: false,
	modalMessage: '',
});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case CLOSE_MODAL:
			return state.merge({
				modalOpen: false,
			});
		case OPEN_MODAL:
			return state.merge({
				modalOpen: true,
			});
		case SET_MODAL_MESSAGE:
			return state.merge({
				modalMessage: action.message,
			});
		default:
			return state;
	}
};

export default reducer;
